import { createContainer } from 'react-sweet-state';

import { LocalStore, PRIVATE_ACTIONS } from './LocalStore';

export const LocalStoreContainer = createContainer(LocalStore, {
  onInit:
    () =>
    ({ setState, dispatch }, { state }) => {
      dispatch(PRIVATE_ACTIONS.init());

      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState, dispatch }, { state }) => {
      dispatch(PRIVATE_ACTIONS.update());

      if (state) {
        setState(state);
      }
    },
});
